import { lazy, Suspense } from 'react';
import { Route, Navigate } from 'react-router-dom';
const AnonymiserPage = lazy(() => import('./pages/AnonymiserPage'));
const SopGeneratorPage = lazy(() => import('./pages/SopGeneratorPage'));
import NotFoundPage from '../../pages/NotFoundPage';
import CustomersPage from './pages/CustomersPage';
import CustomerDetailPage from './pages/CustomerDetailPage';
import UsersPage from './pages/UsersPage';
import SupportTicketsPage from './pages/SupportTicketsPage';
import InboxPage from './pages/InboxPage';
import KnowledgeBasePage from './pages/KnowledgeBasePage';
import KnowledgeBaseEditPage from './pages/KnowledgeBaseEditPage';

import ContentAnalyticsPage from './pages/ContentAnalyticsPage';

/**
 * Success & Support route children — returns <Route> elements as a fragment.
 *
 * All paths use 2-letter codes per route segment convention.
 *
 * These are composed into the parent <Routes> in App.tsx as children
 * of the S&S layout route. NO nested <Routes> — the parent router
 * has full visibility for correct route ranking.
 */
export function SuccessSupportRouteChildren() {
  return (
    <>
      {/* Default redirect to customers */}
      <Route index element={<Navigate to="customers" replace />} />

      {/* Customers */}
      <Route path="customers" element={<CustomersPage />} />
      <Route path="customers/:customerId" element={<CustomerDetailPage />} />

      {/* Users */}
      <Route path="users" element={<UsersPage />} />

      {/* Support Tickets */}
      <Route path="tickets" element={<SupportTicketsPage />} />

      {/* Inbox */}
      <Route path="inbox" element={<InboxPage />} />

      {/* Knowledge Base */}
      <Route path="knowledge-base" element={<KnowledgeBasePage />} />
      <Route path="knowledge-base/:id/edit" element={<KnowledgeBaseEditPage />} />

      {/* Content Analytics */}
      <Route path="analytics" element={<ContentAnalyticsPage />} />
      <Route path="analytics/:id" element={<ContentAnalyticsPage />} />

      {/* Legacy 2-letter code redirects */}
      <Route path="db" element={<Navigate to="../customers" replace />} />
      <Route path="ch" element={<Navigate to="../customers" replace />} />
      <Route path="cu" element={<Navigate to="../customers" replace />} />
      <Route path="cu/:customerId" element={<Navigate to={`../customers/${''}`} replace />} />
      <Route path="us" element={<Navigate to="../users" replace />} />
      <Route path="ac" element={<Navigate to="../customers" replace />} />
      <Route path="en" element={<Navigate to="../customers" replace />} />
      <Route path="tk" element={<Navigate to="../tickets" replace />} />
      <Route path="ib" element={<Navigate to="../inbox" replace />} />
      <Route path="kb" element={<Navigate to="../knowledge-base" replace />} />
      <Route path="or" element={<Navigate to="../customers" replace />} />
      <Route path="gd" element={<Navigate to="../customers" replace />} />
      <Route path="lp" element={<Navigate to="../customers" replace />} />
      <Route path="gm" element={<Navigate to="../customers" replace />} />
      <Route path="ca" element={<Navigate to="../analytics" replace />} />

      {/* Anonymiser admin console */}
      <Route path="anonymiser" element={
        <Suspense fallback={<div className="p-6 text-gray-500">Loading...</div>}>
          <AnonymiserPage />
        </Suspense>
      } />

      {/* SOP Generator */}
      <Route path="sop-generator" element={
        <Suspense fallback={<div className="p-6 text-gray-500">Loading...</div>}>
          <SopGeneratorPage />
        </Suspense>
      } />
      <Route path="sop-generator/:jobId" element={
        <Suspense fallback={<div className="p-6 text-gray-500">Loading...</div>}>
          <SopGeneratorPage />
        </Suspense>
      } />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </>
  );
}
